// React
import React from "react";

import { useTranslation } from "react-i18next";

const NotificationFooter = ({ onViewAll }) => {
  const { t } = useTranslation();

  return (
    <div className="w-full">
      <button
        onClick={onViewAll}
        className="w-full cursor-pointer rounded-lg bg-primary py-2 text-center text-sm font-medium text-white transition-colors hover:bg-primary-strong focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
      >
        {t("notificationPopover:viewAll", "View all")}
      </button>
    </div>
  );
};

export default NotificationFooter;
